<template>
  <div class="addresses-list">
    <ScrolledTable
      class="lg"
      :fix-last="true"
      @nextPage="nextPage"
    >
      <table class="h-table">
        <thead>
          <tr>
            <th
              v-for="column in columns"
              :key="column.id"
              :style="{
                width: getColumnWidth(column),
                minWidth: getColumnWidth(column),
              }"
            >
              <TableHeader
                :column="column"
                :sort-by="sortBy"
                :sort-dir="sortDir"
                :can-sort="isColumnSortable(column)"
                :filter="getColumnFilter(column)"
                @filter="configureFilter"
                @sort="emitSort"
              />
            </th>
            <th width="70"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="entry in entries"
            :key="entry.id"
          >
            <td
              v-for="column in columns"
              :key="column.id"
              :align="column.type === 'number' ? 'right' : null"
            >
              <TableCell
                :entry="entry"
                :column="column"
                :lists="lists"
              />
            </td>
            <td>
              <TableActions
                :entry="entry"
                :can-edit="canEdit"
                @edit="emitEdit"
                @remove="emitRemove"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </ScrolledTable>
    <HorizontalTable
      class="sm"
      @nextPage="nextPage"
    >
      <table class="h-table">
        <tbody>
          <tr
            v-for="column in columns"
            :key="column.id"
          >
            <th>
              <TableHeader
                :column="column"
                :sort-by="sortBy"
                :sort-dir="sortDir"
                :can-sort="isColumnSortable(column)"
                :filter="getColumnFilter(column)"
                @filter="configureFilter"
                @sort="emitSort"
              />
            </th>
            <td
              v-for="entry in entries"
              :key="entry.id"
            >
              <TableCell
                :entry="entry"
                :column="column"
                :lists="lists"
              />
            </td>
          </tr>
          <tr>
            <th />
            <td
              v-for="entry in entries"
              :key="entry.id"
            >
              <TableActions
                :entry="entry"
                :can-edit="canEdit"
                @edit="emitEdit"
                @remove="emitRemove"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </HorizontalTable>
    <ColumnFilterModal
      ref="columnFilterModal"
      @apply="$emit('filter', $event)"
    />
  </div>
</template>

<script>
import ScrolledTable from "@/components/scrolled-table";
import HorizontalTable from "@/components/horizontal-table";
import ColumnFilterModal from "@/components/modals/column-filter-modal";
import TableHeader from "./TableHeader.vue";
import TableCell from "./TableCell.vue";
import TableActions from "./TableActions.vue";

export default {
  components: {
    ScrolledTable,
    HorizontalTable,
    ColumnFilterModal,
    TableHeader,
    TableCell,
    TableActions,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    lists: {
      type: Object,
      default: () => ({}),
    },
    entries: {
      type: Array,
      default: () => [],
    },
    sortBy: {
      type: String,
      default: "",
    },
    sortDir: {
      type: String,
      default: "",
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    columnsWidths () {
      return {
        filial: 115,
        posts: 115,
        paytypes: 115,
        period: 115,
        address: 250,
        coordinates: 92,
        distance: 82,
        price: 82,
      };
    },
    nonSortableColumnsIds () {
      return [
        "coordinates",
      ];
    },
  },
  methods: {
    isColumnSortable ({ id }) {
      return !this.nonSortableColumnsIds.includes(id);
    },
    emitSort({ sortBy, sortDir }) {
      this.$emit("update:sortBy", sortBy);
      this.$emit("update:sortDir", sortDir);
    },
    getColumnWidth ({ id }) {
      const width = this.columnsWidths[id];

      if (!width) {
        return null;
      }

      return `${width}px`;
    },
    getColumnFilter ({ id }) {
      const filter = this.filters[id];

      if (!filter) {
        return null;
      }

      if (filter.type === "list") {
        filter.getList = () => filter.items;
      }

      return filter;
    },
    configureFilter({ column, filter }) {
      this.$refs.columnFilterModal.open({
        name: column.id,
        ...filter,
      });
    },
    emitEdit(entry) {
      this.$emit("edit", entry);
    },
    emitRemove(entry) {
      this.$emit("remove", entry);
    },
    nextPage() {
      this.$emit("nextPage");
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/vars";

.h-table {
  table-layout: fixed;
}

.lg {
  padding-bottom: 5px;
}

.sm {
  display: none;
  margin-left: -21px;
  margin-right: -21px;
  padding-bottom: 15px;

  th {
    width: 85px;
    vertical-align: top;
  }

  td {
    width: 240px;
    min-width: 240px;
  }
}

@include onlyMobile {
  .lg {
    display: none;
  }

  .sm {
    display: block;
  }
}
</style>
